module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./SelectBirthdayVideo.js"));
	}, "SelectBirthdayVideo");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=SelectBirthdayVideo!./src/pages/Shop/Home/MemberBirthday/SelectBirthdayVideo.js
// module id = 1849
// module chunks = 367